import e from"react";const u=()=>{const[t,s]=e.useState(!1);return e.useEffect(()=>{s(!0)},[]),t};export{u as useIsMounted};
//# sourceMappingURL=use-is-mounted.js.map
